import { addAuthInterceptors } from '@dentalux/security'

import { InsuranceCompany } from '@ana/shared'
import axios from 'axios'

const http = axios.create({
  baseURL: process.env.REACT_APP_INSURANCE_URL,
})

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
addAuthInterceptors(http)

export const getInsuranceCompanies = async (): Promise<InsuranceCompany[]> => {
  const { data } = await http.get('/insurance-companies')

  return data
}
